import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import ExclamationTriangleIcon from 'components/atoms/icons/exclamation-triangle';

import s from '../../styles.module.scss';

const CroStatusBadge: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div
      data-cy="criticalReadingsOnly-status-tag"
      className={classNames(s.badge, s.cro)}
    >
      <p>{t('labels.criticalReadingsOnly')}</p>
      <ExclamationTriangleIcon />
    </div>
  );
};
export default CroStatusBadge;
